<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Suas solicitações
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">
                          <base-input class="mr-2 flex-grow-2" type="number" placeholder="número" v-model="filtros.numero"></base-input>

                          <base-input class="mr-2 flex-grow-2" type="date" placeholder="data" v-model="filtros.data"></base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-if="opcoesFiltros.dentista"
                              v-model="filtros.dentista"
                              track-by="valor"
                              label="nome"
                              :options="opcoesFiltros.dentista"
                              placeholder="por dentista"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os dentistas</span>
                            </multiselect>
                          </base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-if="opcoesFiltros.paciente"
                              v-model="filtros.paciente"
                              track-by="valor"
                              label="nome"
                              :options="opcoesFiltros.paciente"
                              placeholder="por paciente"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os pacientes</span>
                            </multiselect>
                          </base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-model="filtros.status"
                              track-by="valor"
                              label="nome"
                              :options="status"
                              placeholder="por status"
                              :multiple="true"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os status</span>
                            </multiselect>
                          </base-input>
                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="ordensServico">
                            <template slot="columns">
                              <th>Número</th>
                              <th>Data</th>
                              <th>Dentista</th>
                              <th>Paciente</th>
                              <th>Status</th>
                              <th></th>
                            </template>

                            <template slot-scope="{row}">
                              <th scope="row" :class="{ 'notViewed': row.viewLab == 0 }">
                                <span>{{row.id}}</span>
                              </th>
                              <th scope="row"  :class="{ 'notViewed': row.viewLab == 0 }">
                                <span class="name mb-0 text-sm">{{formatarData(row.created_at)}}</span>
                              </th>
                              <td :class="{ 'notViewed': row.viewLab == 0 }">
                                {{row.dentista.nome}}
                              </td>
                              <td :class="{ 'notViewed': row.viewLab == 0 }">
                                {{row.paciente+', '+row.idade}}
                              </td>
                              <td :class="{ 'notViewed': row.viewLab == 0 }">
                                <badge class="mr-4" :type="coresStatus[row.status]">
                                  {{nomeStatus(row.status)}}
                                </badge>
                              </td>
                              <td class="text-right"  :class="{ 'notViewed': row.viewLab == 0 }">
                                  <base-button :to="'/solicitacao/'+row.id" type="default" icon="far fa-eye" size="sm" title="Visualizar solicitação"></base-button>
                                  <base-button v-if="row.status < 1" @click="mudarStatus(row,5)" type="danger" icon="fas fa-times" size="sm" class="ml-xs" title="Recusar solicitação" v-show="user.tipo == 'lab'"></base-button>
                              </td>

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                      <div style="padding: 20px; text-align: right;" v-show="user.tipo == 'lab'">
                        <base-button size="sm" class="clickable" type="info" @click="goCsv()">Exportar Solicitações</base-button>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ordens from '@/cflow/ordens.js'
  import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import config from 'config';
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      goCsv: function() {

          const user = storage.get('user');
          const api = config[process.env.NODE_ENV].api.endpoint;
          const csv = `${api}/csv/solicitacoes?token=${user.token}`;
          window.location = csv;

      },
      nomeStatus: function(status) {
        for(let item of this.status){
          if(item.valor == status) return item.nome;
        }
      },
      mudarStatus: function(ordem,status) {
        ordens.mudarStatus(ordem.id,status).then( res => {
          if(res){
            ordem.status = status;
          }
        } )
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          ordens.listar({filtros: this.filtros}).then(res => {
            this.ordensServico = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(erro => {
            console.err('Ocorreu um erro', erro)
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped += this.ordensServico.length;
        this.initLoad(this.skiped);
      },
      initLoad: function(skip) {
        this.loading = true;
        var user = storage.get("user");
        var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          labId = user.id;
        }
        Promise.all([ordens.listar([],skip),parametros.params(labId),ordens.opcoesFiltro()]).then( res => {
          this.ordensServico = this.ordensServico.concat(res[0]);
          //this.ordensServico = res[0];
          this.status = res[1].status;
          this.opcoesFiltros = res[2];
          this.loading = false;
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      },
      '$route.query': function(){
        this.ordensServico = [];
        this.initLoad(0);
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        ordensServico:[],
        status: [],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        lastViewed: 0,
        filtros: {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        },
        user: {}
      }
    },
    mounted(){
      const _this = this;
      _this.user = storage.get("user");
      _this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}

.notViewed {
  background: rgba(255,153,51, 0.2);
}
</style>
